import { createFeedbackDialog } from './feedback-dialog-module';

/**
 * Share a URL via the native Web Share API, falling back to copying it to the clipboard
 * (with a confirmation dialog) on browsers without it.
 */
export function shareUrl(url) {
  if (navigator.share) {
    navigator
      .share({
        title: 'Clevertronic',
        text: 'Schau dir dieses Gerät an!',
        url: url,
      })
      .catch(function () {});
  } else {
    const clipboardPromise =
      navigator.clipboard && typeof navigator.clipboard.write === 'function' && typeof ClipboardItem === 'function'
        ? navigator.clipboard.write([new ClipboardItem({ ['text/plain']: url })])
        : navigator.clipboard?.writeText(url);

    if (!clipboardPromise) {
      createFeedbackDialog('feedback_error', 'Die URL konnte nicht kopiert werden.');
      return;
    }

    clipboardPromise
      .then(function () {
        createFeedbackDialog('feedback_success', 'Die URL wurde in deine Zwischenablage kopiert.');
      })
      .catch(function () {
        createFeedbackDialog('feedback_error', 'Die URL konnte nicht kopiert werden.');
      });
  }
}
